/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LogisticsUser } from './LogisticsUser';
import {
    LogisticsUserFromJSON,
    LogisticsUserFromJSONTyped,
    LogisticsUserToJSON,
} from './LogisticsUser';
import type { Token } from './Token';
import {
    TokenFromJSON,
    TokenFromJSONTyped,
    TokenToJSON,
} from './Token';

/**
 * 
 * @export
 * @interface SignInUser201ResponseAllOfData
 */
export interface SignInUser201ResponseAllOfData {
    /**
     * 
     * @type {LogisticsUser}
     * @memberof SignInUser201ResponseAllOfData
     */
    user: LogisticsUser;
    /**
     * 
     * @type {Token}
     * @memberof SignInUser201ResponseAllOfData
     */
    token: Token;
}

/**
 * Check if a given object implements the SignInUser201ResponseAllOfData interface.
 */
export function instanceOfSignInUser201ResponseAllOfData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "user" in value;
    isInstance = isInstance && "token" in value;

    return isInstance;
}

export function SignInUser201ResponseAllOfDataFromJSON(json: any): SignInUser201ResponseAllOfData {
    return SignInUser201ResponseAllOfDataFromJSONTyped(json, false);
}

export function SignInUser201ResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignInUser201ResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user': LogisticsUserFromJSON(json['user']),
        'token': TokenFromJSON(json['token']),
    };
}

export function SignInUser201ResponseAllOfDataToJSON(value?: SignInUser201ResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user': LogisticsUserToJSON(value.user),
        'token': TokenToJSON(value.token),
    };
}

